import { QuizPageUrlRule } from '../../../types';
export function checkConditions({ conditions, url, userCurrentRoleType }) {
    if (conditions.pageUrlRule === QuizPageUrlRule.regexp && !url.match(conditions.pageUrl)) {
        return false;
    }
    if (conditions.pageUrlRule === QuizPageUrlRule.exactly && url !== conditions.pageUrl) {
        return false;
    }
    if (conditions.pageUrlRule === QuizPageUrlRule.contains && !url.includes(conditions.pageUrl)) {
        return false;
    }
    if (conditions.roles &&
        conditions.roles.length > 0 &&
        (!userCurrentRoleType || !conditions.roles.includes(userCurrentRoleType))) {
        return false;
    }
    return true;
}
//# sourceMappingURL=check-conditions.js.map